import { render, staticRenderFns } from "./career-tab.vue?vue&type=template&id=0aabd883&scoped=true&"
import script from "./career-tab.vue?vue&type=script&lang=js&"
export * from "./career-tab.vue?vue&type=script&lang=js&"
import style0 from "./career-tab.vue?vue&type=style&index=0&id=0aabd883&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aabd883",
  null
  
)

export default component.exports